import { useRef } from 'react'
import { FormControl } from 'baseui/form-control'
import { KIND, SIZE } from 'baseui/button'
import { Notification, KIND as NOTIFICATION_KIND } from 'baseui/notification'
import SDButton from '@/shared/components/SDComponents/SDButton/SDButton'

import useNettingUpdater from './useNettingUpdater'
import {
  ActionsRow,
  NotificationsWrapper,
  FileRow,
  FileLabel,
  FileName,
  ClearFileButton,
  Stack,
  ProviderInfo,
  HeaderRow,
} from './styled-components'

const NettingUpdaterForm = () => {
  const { form, result, t } = useNettingUpdater()
  const inputRef = useRef(null)

  const hasSuccessMessage = result.message && !result.error
  const hasErrorMessage = result.error

  return (
    <div>
      <HeaderRow>
        <SDButton
          onClick={form.onGoBack}
          size={SIZE.mini}
          kind={KIND.secondary}
        >
          {t('netting.button_back')}
        </SDButton>
      </HeaderRow>

      <ProviderInfo>
        {t('netting.provider_label')}: <strong>{form.providerName}</strong>
      </ProviderInfo>

      <FileRow>
        <FormControl
          label={`${t('netting.label_file')}${form.acceptedExtensions ? ` (${form.acceptedExtensions})` : ''}`}
        >
          <Stack>
            <input
              ref={inputRef}
              type="file"
              accept={form.acceptedExtensions || undefined}
              onChange={form.onFileChange}
              style={{ display: 'none' }}
            />
            <FileLabel onClick={() => inputRef.current?.click()}>
              {t('netting.button_choose_file')}
            </FileLabel>
            {form.fileName && (
              <FileName>
                {form.fileName}
                <ClearFileButton onClick={() => {
                  if (inputRef.current) inputRef.current.value = ''
                  form.onFileClear()
                }}>
                  &times;
                </ClearFileButton>
              </FileName>
            )}
          </Stack>
        </FormControl>
      </FileRow>

      <ActionsRow>
        <SDButton
          onClick={form.onSubmit}
          isLoading={form.isSubmitting}
          disabled={!form.isValid || form.isSubmitting}
          size={SIZE.compact}
        >
          {t('netting.button_submit')}
        </SDButton>
      </ActionsRow>

      {hasSuccessMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.positive}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(result.message)}
          </Notification>
        </NotificationsWrapper>
      )}

      {hasErrorMessage && (
        <NotificationsWrapper>
          <Notification
            kind={NOTIFICATION_KIND.negative}
            overrides={{ Body: { style: { width: 'auto', marginLeft: 0 } } }}
          >
            {String(result.error)}
          </Notification>
        </NotificationsWrapper>
      )}
    </div>
  )
}

export default NettingUpdaterForm
